interface DashboardTabsProps {
  activeTab: number;
  setCurrentTab: (tab: number) => void;
}

const DashboardTabs = ({ activeTab, setCurrentTab }: DashboardTabsProps) => {
    return(
        <div className="tabs">
        <div
          className={["tab", activeTab === 0 ? "active" : ""].join(" ")}
          onClick={() => setCurrentTab(0)}
        >
          All Tests
        </div>
        <div
          className={["tab", activeTab === 1 ? "active" : ""].join(" ")}
          onClick={() => setCurrentTab(1)}
        >
          In Progress
        </div>
        <div
          className={["tab", activeTab === 2 ? "active" : ""].join(" ")}
          onClick={() => setCurrentTab(2)}
        >
          Completed
        </div>
        <div
          className={["tab", activeTab === 3 ? "active" : ""].join(" ")}
          onClick={() => setCurrentTab(3)}
        >
          Not started
        </div>
      </div>
    )
};

export default DashboardTabs;
